// eslint-disable-next-line no-unused-vars
export default ( {
	app,
	authService,
	layouts,
	loadedSlices,
} ) => {

	const lazyLoadInboxComponent = ( { component, } ) => {
		return () => {
			if ( !loadedSlices.has( "@teaming/slice-inbox" ) ) {
				return import( "@teaming/slice-inbox" ).then( async ( { inboxSlice, } ) => {
					inboxSlice();
					loadedSlices.set( "@teaming/slice-inbox", true );
					return app.component( component );
				} );
			}
			return Promise.resolve( app.component( component ) );
		};
	};
	return [
		{
			path: "/inbox",
			name: "",
			meta: { title: "slice-inbox.routes.list", },
			component: layouts.StandardAppLayout,
			props: true,
			children: [
				{
					path: "",
					name: "Inbox",
					component: lazyLoadInboxComponent( { component: "TeamlessInboxHOC", } ),
					props: true,
				},
			],
			beforeEnter: authService.authGuard,
		}
    ];
};
